import React from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { getUserState } from '@carvana/core-auth';

const SoftPullMfeModal = () => {
  const { isLoggedIn } = getUserState();

  return (
    <MfeReactComponent
      component="default"
      module="SoftPullModule"
      softPullSource="accountUi"
      externalIsLoggedIn={isLoggedIn}
    />
  );
};

export default SoftPullMfeModal;
